import { Link } from 'react-router-dom';

const ReportDashboard = () => {
    // const history = useHistory();

    return (
        <>
            <div className="col-lg-12">
                <div className="card card-radius">
                    <div className="header card-header custum-bg-warning rounded">
                        <h2 className="text-white">My Reports</h2>
                    </div>
                    <div className="body text-center card-body-shadow">
                        <div className="row clearfix">
                            <div className="col-lg-4 col-md-8 col-sm-12">
                                <img className="rounded-circle" alt="75x75" src="http://via.placeholder.com/75x75"/><br></br>
                                <h5>Report 1</h5>
                                <p>sub title</p>
                                <Link to='/project-reports' className="mt-2 btn button">Total Partner Dashboard</Link>
                            </div>
                            <div className="col-lg-4 col-md-8 col-sm-12">
                                <img className="rounded-circle" alt="75x75" src="http://via.placeholder.com/75x75"/><br></br>
                                <h5>Report 2</h5>
                                <p>sub title</p>
                                <Link to={'/project-reports'} className="mt-2 btn button">Client Dashboard</Link>
                            </div>
                            <div className="col-lg-4 col-md-8 col-sm-12">
                            <img className="rounded-circle" alt="75x75" src="http://via.placeholder.com/75x75"/><br></br>
                            <h5>Report 2</h5>
                                <p>sub title</p>
                                <Link to={'/project-reports'} className="mt-2 btn button">Feedback Anaylsis</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default ReportDashboard;